import { render, staticRenderFns } from "./PingButton.vue?vue&type=template&id=12fc8cb0&scoped=true&"
import script from "./PingButton.vue?vue&type=script&lang=js&"
export * from "./PingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fc8cb0",
  null
  
)

export default component.exports